import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,{staticClass:"ampifire-banner"},[_c('div',{staticClass:"ampifire-banner--content d-inline-block col-lg-10 col-md-8 col-sm-12"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }